import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

// Redux: alterna o tipo do menu (default <-> condensed) mantendo o estado
// e as classes do body em sincronia (em vez de mexer na classe na mão).
import { changeSidebarType } from "../../store/actions";

import logo from "../../assets/images/logo-preto.png";
import logoLightPng from "../../assets/images/logo-preto.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-preto.png";

const Sidebar = props => {

  
  var body = document.body
  // console.log(body)
  const bodyElement = document.querySelector('body');
// if (bodyElement.classList.contains('vertical-collpsed')) {
//   console.log('The body has the class "right-bar-enabled"');
// } else {
//   console.log('The body does not have the class "right-bar-enabled"');
// }

  // Expande/recolhe o menu lateral usando o estado do Redux (changeSidebarType),
  // que é o mecanismo oficial do tema: "default" = menu completo, "condensed" =
  // só ícones. Isso mantém o estado e as classes do body sincronizados — o hack
  // anterior (toggle de classe na mão) desincronizava e travava o menu.
  // Só existe no desktop: no mobile este item é escondido (SidebarContent) e a
  // saga ignora o tipo recolhido de qualquer forma.
  function tToggle() {
    const novoTipo = props.type === "condensed" ? "default" : "condensed";
    // Persiste a preferência para o menu manter o estado após recarregar.
    try {
      localStorage.setItem("leftSideBarType", novoTipo);
    } catch (e) {
      // localStorage indisponível — apenas não persiste
    }
    // Sem passar isMobile: a saga deriva o viewport sozinha.
    props.changeSidebarType(novoTipo);
  }

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="21" />
            </span>
            
            <span className="syskeeper" style={{color:"black", padding:"10px 5px 2px", fontWeight:"bold",fontSize:"18px"}} >
              SYSKEEPER
            </span>
                  
            
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoLightSvg} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLightSvg} alt="" height="19" />
            </span>
          </Link>
        </div>

        <div data-simplebar className="h-100">
          <SidebarContent
            onToggleMenu={tToggle}
            sidebarType={props.type}
            onCloseMobileMenu={props.onCloseMobileMenu}
          />
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
  onCloseMobileMenu: PropTypes.func,
  changeSidebarType: PropTypes.func,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  { changeSidebarType }
)(withRouter(withTranslation()(Sidebar)));
